import axios from "axios";
import { errorHandler } from "../exports/error_management";
const AWS = require("aws-sdk");

const guid = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
};

const state = {
  aws_credentials: null,
  db_params: null,
  url: null,
  data_url: null,
  reportLoading: false,
};

const getters = {};

const mutations = {
  set_credentials(state, aws_credentials) {
    state.aws_credentials = aws_credentials;
  },
  set_db_params(state, db_params) {
    state.db_params = db_params;
  },
  set_url(state, url) {
    state.url = url ?? null;
  },

  set_data_url(state, data_url) {
    state.data_url = data_url ?? null;
  },

  set_report_loading(state, reportLoading) {
    state.reportLoading = reportLoading;
  },
};

const actions = {
  async fetchCredentials({ commit }) {
    try {
      const resp = await axios.get(`js-report/credentials`);
      const { aws_credentials, db_params } = resp.data.success.data;
      commit("set_credentials", aws_credentials);
      commit("set_db_params", db_params);
    } catch (err) {
      console.error("fetchCredentials:", err);
      errorHandler(err);
    }
  },

  async downloadStatement({ commit }, { order_id, statement_type }) {
    try {
      commit("set_report_loading", true);
      const resp = await axios.get(
        `order/${order_id}/get-statement-url?statement_type=${statement_type}`
      );
      console.log("downloadStatement resp", resp);

      const url = resp.data.success.message;
      commit("set_url", url);
    } catch (err) {
      errorHandler(err);
    } finally {
      commit("set_report_loading", false);
    }
  },

  async lambdaDownload(
    { dispatch, state, commit, rootGetters },
    { shortid, query, fileName, data, mediaType, statement_type }
  ) {
    try {
      commit("set_report_loading", true);
      console.log("shortid:", shortid);
      console.log("rpt data:", data);

      await dispatch("fetchCredentials");
      await this._vm.$nextTick();

      console.log("crdentials", state.aws_credentials);

      const {
        key: accessKeyId,
        secret: secretAccessKey,
        token: sessionToken,
        region,
      } = state.aws_credentials;

      const options = {
        region,
        accessKeyId,
        secretAccessKey,
        sessionToken,
      };

      AWS.config.update(options);
      const lambda = new AWS.Lambda();

      console.log("db_params", state.db_params);

      let { database, host } = state.db_params || {};

      if (host == "localhost" || host.slice(0, 4) == "127.") {
        database = null;
      }
      const key_path = guid();

      const Payload = JSON.stringify({
        renderRequest: {
          template: {
            shortid,
            params: {
              database,
              query,
              key_path,
              mediaType,
              fileName,
              statement_type,
            },
          },
          data,
        },
      });

      let FunctionName = rootGetters.js_report_lambda_name;
      if (!FunctionName) {
        FunctionName = `jsreportFunction${
          rootGetters.is_development ? "" : ":prod"
        }`;
      }

      console.log("jsreport Lambda FunctionName:", FunctionName);
      const params = {
        FunctionName,
        Payload,
      };

      const { Payload: resp } = await lambda.invoke(params).promise();

      console.log("lambda resp:", resp);

      const {
        errorType,
        errorMessage,
        // statusCode,
        body: data_url,
      } = JSON.parse(resp);

      if (errorType !== "Function.ResponseSizeTooLarge" && errorMessage) {
        throw new Error(errorMessage);
      }

      if (errorType == "Function.ResponseSizeTooLarge") {
        let jsreport_storage_domain = rootGetters.jsreport_storage_domain;
        const url = `https://${jsreport_storage_domain}/${key_path}`; //      `https://${atob(base64)}/${key_path}`;
        console.log("download url:", url);
        commit("set_url", url);
      } else {
        commit("set_data_url", data_url);
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      commit("set_report_loading", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
